import type { AlphaOperationNoteKey } from '@snap-types/models/alpha-quote-line';
import type { CalculatedLineItemData } from '@snap-types/models/auto-configurator/state';

/** The calculated columns that name an operation, all of them nullish strings. */
type OperationNameKey = Extract<
  keyof CalculatedLineItemData,
  `${string}Operation` | `${string}ServiceId`
>;

type OperationNoteConfig = {
  label: string;
  operationKey: OperationNameKey;
};

/**
 * Ordered the way an apply builds the work order, so the dialog reads in the
 * same sequence the notes will appear in Visual. Keyed by note column, which
 * makes a note added to the model a type error until it is labelled here.
 */
export const operationNotes: Record<
  AlphaOperationNoteKey,
  OperationNoteConfig
> = {
  toolingNote: { label: 'Tooling', operationKey: 'toolingOperation' },
  headingNote: { label: 'Heading', operationKey: 'headingOperation' },
  trimmingNote: { label: 'Trimming', operationKey: 'trimmingOperation' },
  pinchNote: { label: 'Pinch', operationKey: 'pinchOperation' },
  rollingNote: { label: 'Rolling', operationKey: 'rollingOperation' },
  shankSlottingNote: {
    label: 'Shank Slotting',
    operationKey: 'shankSlottingOperation',
  },
  sawSlottingNote: {
    label: 'Saw Slotting',
    operationKey: 'sawSlottingOperation',
  },
  dephosNote: { label: 'DEPHOS', operationKey: 'dephosServiceId' },
  heatTreatNote: { label: 'Heat Treat', operationKey: 'heatTreatServiceId' },
  surfaceFinishNote: {
    label: 'Surface Finish',
    operationKey: 'surfaceFinishServiceId',
  },
  postFinishNote: { label: 'Post Finish', operationKey: 'postFinishServiceId' },
  osp2Note: { label: 'OSP 2', operationKey: 'osp2ServiceId' },
  osp3Note: { label: 'OSP 3', operationKey: 'osp3ServiceId' },
};

export const operationNoteKeys = Object.keys(
  operationNotes,
) as AlphaOperationNoteKey[];
